import { render, staticRenderFns } from "./DzDetail.vue?vue&type=template&id=3856410c&scoped=true"
import script from "./DzDetail.vue?vue&type=script&lang=js"
export * from "./DzDetail.vue?vue&type=script&lang=js"
import style0 from "./DzDetail.vue?vue&type=style&index=0&id=3856410c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3856410c",
  null
  
)

export default component.exports